// extracted by mini-css-extract-plugin
export default {"NoSearchResults":"NoSearchResults_NoSearchResults__eXB3n","NoSearchResults__inner":"NoSearchResults_NoSearchResults__inner__EIwtT"};